var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_439_15384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_439_15384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14961 20H15.8496V17C15.8496 15.8833 15.4789 14.9167 14.7376 14.1C13.9956 13.2833 13.0829 12.875 11.9996 12.875C10.9163 12.875 10.0036 13.2833 9.26161 14.1C8.52028 14.9167 8.14961 15.8833 8.14961 17V20ZM4.59961 21.5V20H6.64961V17C6.64961 15.9167 6.92894 14.9167 7.48761 14C8.04561 13.0833 8.80794 12.4167 9.77461 12C8.80794 11.5833 8.04561 10.9167 7.48761 10C6.92894 9.08333 6.64961 8.08333 6.64961 7V4H4.59961V2.5H19.3996V4H17.3496V7C17.3496 8.08333 17.0706 9.08333 16.5126 10C15.9539 10.9167 15.1913 11.5833 14.2246 12C15.1913 12.4167 15.9539 13.0833 16.5126 14C17.0706 14.9167 17.3496 15.9167 17.3496 17V20H19.3996V21.5H4.59961Z",
    fill: "#eba10f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.2895b9394d5d82fd5e5ee00a6eff2e88.svg";
export { ForwardRef as ReactComponent };